import { useEffect } from "react";
import NotFound404 from "../../assets/svg/404.svg";
import NotFound404Dark from "../../assets/svg/404-dark.svg";
import ContentLayoutManagement from "../../layouts/ContentLayoutManagement";
import { useDispatch, useSelector } from "react-redux";
import
{
  changeDataBreadcrumb,
  changeLayoutName,
} from "../../store/reducers/layoutSlice";
import { resetAllDrawer } from "../../store/reducers/drawerSlice";
import { RootState } from "../../store/store";

const Page404 = () =>
{
  const dispatch = useDispatch();
  useEffect(() =>
  {
    dispatch(changeLayoutName("/404"));
    dispatch(changeDataBreadcrumb([]));
    dispatch(resetAllDrawer());
    return () =>
    {
      dispatch(changeLayoutName(""));
      dispatch(changeDataBreadcrumb([]));
    };
  }, []);

  const theme = useSelector((state: RootState) => state.appCommonSlice.theme)
  return (
    <ContentLayoutManagement>
      <div className="flex justify-center top-1/2 translate-y-1/2">
        <img src={theme?.includes('dark') ? NotFound404Dark : NotFound404} alt="img404" />
      </div>
    </ContentLayoutManagement>
  );
};

export default Page404;
